import { Component } from '@angular/core';

@Component({
  selector: 'mnf-authentication-banner',
  standalone: false,
  templateUrl: './authentication-banner.component.html',
  styleUrl: './authentication-banner.component.scss'
})
export class AuthenticationBannerComponent {
  icons = [
    'assets/icon/monific-icon-n-logo.svg',
    'assets/icon/cnbv-logo.svg',
    'assets/icon/condusef-logo.svg',
    'assets/icon/bdm-logo.svg'
  ]
}
